<script setup lang="ts">
  import HeaderUser from './header-user.vue'
  import HeaderCertification from './header-certification.vue'
  import LanguageSwitcher from '@/components/language-switcher/index.vue'
  import appStore from '@/pinia/index';
  import {menu as piniaMenu} from '../../pinia/menu';

  const router = useRouter();

  const menuStore = piniaMenu();

  const breadcrumbNames = computed(() => {
    return appStore.menu.getBreadcrumbNames();
  });

  // 使用 ref 替代 computed，因为 aStore 不是响应式的
  const showDashboardBtn = ref(false);

  // 更新 showDashboardBtn 的方法
  const updateShowDashboardBtn = () => {
    const userInfo = aStore.get('userInfo') || {};
    showDashboardBtn.value = !!userInfo.boardAccess;
  };

  const isLastItem = (index: number) => {
    return index === (breadcrumbNames.value.length - 1);
  };

  function toDashBoardBox() {
    const routeLocation = router.resolve('/deviceDashboard');
    window.open(routeLocation.href, '_blank');
  }

  // 初始化时读取一次值
  onMounted(() => {
    updateShowDashboardBtn();
  });

  // 暴露方法给父组件调用
  defineExpose({
    updateShowDashboardBtn
  });

</script>

<template>
  <div class="mainHeader">
    <div class="breadcrumbWrap">
      <div v-for="(item, index) in breadcrumbNames" class="breadcrumbItem" :class="{lastBreadcrumb: isLastItem(index)}">
        <span>{{item}}</span>
        <span v-if="!isLastItem(index)" class="dividingLine" :class="{lastDividingLine: isLastItem(index + 1)}">/</span>
      </div>
    </div>
    <!-- <div class="organization">
      <div class="label">选择组织机构：</div>
      <div class="select">
        <el-cascader class="cus-cascader" :options="options" :props="{checkStrictly: true}" clearable />
      </div>
    </div> -->
    <div class="headerContent">
      <LanguageSwitcher />
      <div v-if="showDashboardBtn" class="toDashBoardBox" @click="toDashBoardBox">
        <img src="./img/fencao.png" alt="fencao" class="fencaoImg">
        蜂巢看板
      </div>
      <HeaderCertification></HeaderCertification>
      <div class="userWrap">
        <HeaderUser></HeaderUser>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .mainHeader {
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    padding-left: 20px;
    padding-right: 20px;
    border-bottom: 1px solid var(--border-color-middle);

    .breadcrumbWrap {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: var(--color-text-placeholder);
      .breadcrumbItem {
        .dividingLine {
          margin: 0 8px;
        }
      }
      .lastBreadcrumb {
        color: var(--color-text-regular);
      }
      .lastDividingLine {
        color: var(--color-text-regular);
      }
    }

    .organization {
      margin-left: 24px;
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .label {
        color: var(--color-text-regular);
        text-align: right;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
      }

      .select {
        width: 260px;
        .cus-cascader {
          width: 100%;
        }
      }
    }

    .headerContent {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 16px;
      .userWrap {
        margin-left: 0;
      }

      .toDashBoardBox {
        border: 1px solid #4A7DF7;
        color: #4A7DF7;
        padding: 4px 12px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .fencaoImg {
          width: 20px;
          margin-right: 4px;
        }
      }
    }


  }
</style>

